import HTTP from '../common/http-common';

const END_POINT = '/consumable';

const listConsumable = () => HTTP.get(END_POINT);
const getConsumable = (id) => HTTP.get(END_POINT + "/" + id);

const isExistConsumableCode = (code, id) => HTTP.get(END_POINT +  "/exist", {
    cache: false,
    params: {
        code:  code,
        id: id
    }
});

const insertConsumable = (data) => HTTP.post(END_POINT, {
    consumableCode: data.consumableCode,
    consumableName: data.consumableName,
    price: data.price,
    unitPrice: data.unitPrice,
    unitOfPrice: data.unitOfPrice,
    size: data.size,
    unitOfSize: data.unitOfSize,
    distributor: data.distributor,
    supplierCode: data.supplierCode,
    consumableType: data.consumableType,
    formular: data.formular,
    colorList: data.colorList
});
const updateConsumable = (data) => HTTP.post(END_POINT + "/" + data.consumableId, {
    consumableCode: data.consumableCode,
    consumableName: data.consumableName,
    price: data.price,
    unitPrice: data.unitPrice,
    unitOfPrice: data.unitOfPrice,
    size: data.size,
    unitOfSize: data.unitOfSize,
    distributor: data.distributor,
    supplierCode: data.supplierCode,
    consumableType: data.consumableType,
    formular: data.formular,
    colorList: data.colorList
});

const deleteConsumable = (id) => HTTP.delete(END_POINT + "/" + id);

export default {
    listConsumable,
    getConsumable,
    isExistConsumableCode,
    insertConsumable,
    updateConsumable,
    deleteConsumable

}